function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as Constants from "./constants";
/**
 * Reducer de gestion de l'utilisateur connecté dans le store
 * @private
 * @param {object} state Le state de l'application
 * @param {object} action L'action contenant le type et la valeur
 */

function manageConnectedUser(state, action) {
  if (state === void 0) {
    state = Constants.INITIAL_STATE;
  }

  var nextState;

  switch (action.type) {
    case Constants.SET_CONNECTED_USER:
      // Mise à jour de l'utilisateur
      nextState = _extends({}, state, {
        user: action.value
      });
      return nextState || state;

    default:
      return state;
  }
}

export { manageConnectedUser };